<template>
    <PopupTemplate
        v-model="isOpen"
        :img-raw="imgSrc"
        :img-alt="t('vue.free_plan_post_continue_popup_img_alt')"
        :title="t('vue.free_plan_post_continue_popup_title')"
        @close="handleClose"
    >
        <template #body>
            <div class="free-plan-post-popup-description">
                <p
                    v-html="
                        t(
                            'vue.free_plan_post_continue_popup_description_primary_html',
                        )
                    "
                />
                <p>
                    {{
                        t(
                            "vue.free_plan_post_continue_popup_description_secondary",
                        )
                    }}
                </p>
            </div>
        </template>

        <template #actions>
            <AtomicButton
                color="yellow"
                size="lg"
                class="border-transparent bg-[#088BEA] text-white hover:text-gray-100 focus:ring-[#088BEA] disabled:bg-gray-300 disabled:text-white"
                @click="handleClose"
            >
                {{ t("vue.free_plan_post_popup_continue_button") }}
            </AtomicButton>
        </template>
    </PopupTemplate>
</template>

<script setup lang="ts">
import { computed } from "vue";
import imgSrc from "@/assets/images/free-plan-post-continue.svg?raw";
import PopupTemplate from "@/components/Atomic/Dialogs/PopupTemplate.vue";
import AtomicButton from "@/components/Atomic/Buttons/AtomicButton.vue";
import { useTranslations } from "@/composables/useTranslations.ts";

const props = defineProps<{
    modelValue: boolean;
}>();

const emit = defineEmits<{
    (e: "update:modelValue", value: boolean): void;
    (e: "close"): void;
}>();

const { t } = useTranslations();

const isOpen = computed({
    get: () => props.modelValue,
    set: (value: boolean) => emit("update:modelValue", value),
});

function handleClose() {
    emit("update:modelValue", false);
    emit("close");
}
</script>

<style scoped>
.free-plan-post-popup-description {
    display: flex;
    flex-direction: column;
    gap: 18px;
    color: #3f3f46;
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 142%;
}

:deep(.modal-body) {
    max-width: 433px !important;
    width: 100%;
}

.free-plan-post-popup-description p {
    margin: 0;
}
</style>
